export default "__VITE_ASSET__ddb66afd__"